import { Route, Routes } from 'react-router'
import EditForm from './SubscriptionForm/EditForm'

const TelesalesForm = () => {
  return (
    <Routes>
      <Route path='edit/:id' element={<EditForm />} />
    </Routes>
  )
}

export default TelesalesForm
